import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs/index";
import {ActivatedRoute} from "@angular/router";
import {PreparationConditionnementSupplier} from "../../preparation-conditionnement-resolver.service";
import {
  PreparationConditionnementService
} from "../../../core/services/conditionnements/preparation-conditionnement.service";
import {UtilsService} from "../../../core/utils/utils.service";
import {HELP_FOLDERS, MSG_KEY, MSG_SEVERITY} from "../../../core/constants";
import {PointDeLivraisonDTO} from "../../../core/dtos/point-de-livraison-d-t-o";
import {RoutemapService} from "../../../core/services/routemap.service";
import {PrintMenuService} from "../../../core/services/gestionmenus/print-menu.service";
import {LigneConditionnementDetailsDto} from "../../../core/dtos/conditionnement/ligne-conditionnement-details-dto";
import {InternationalizationService} from "../../../core/services/i8n/i8n.service";
import {ProductionService} from "../../../core/services/gestion-production/production.service";
import {FermeturePonctuelleFilter} from "../../../core/dtos/fermeture-ponctuelle/FermeturePonctuelleFilter";
import {FermeturePonctuelleDTO} from "../../../core/dtos/fermeture-ponctuelle/FermeturePonctuelleDTO";
import {FermeturePoncutelleService} from "../../../core/services/entities/fermeture-poncutelle.service";
import {ToastService} from "../../../core/services/technique/toast.service";
import {ButtonThemeEnum} from "../../../shared/ui/button/button-theme-enum";

@Component({
    selector: 'yo-preparation-calcul-conditionnement',
    templateUrl: './preparation-calcul-conditionnement.component.html',
    styleUrls: ['./preparation-calcul-conditionnement.component.scss'],
    standalone: false
})
export class PreparationCalculConditionnementComponent implements OnInit, OnDestroy {

  data: LigneConditionnementDetailsDto[];
  subscriptionRoute: Subscription;
  updateDateSub: Subscription;
  displayErrors: boolean = false;
  subscriptionCalcul: Subscription;
  loadingVisible: boolean;
  idPlanProduction: number;
  errors: any = [];
  NoDataText: string;
  idParentSelected: number;
  expandAll: boolean = false;
  plcsNotTakenAccount: PointDeLivraisonDTO[] = [];
  readonly UtilsService = UtilsService;
  pathFile: string = HELP_FOLDERS.CONDITIONNEMENT + '/conditionnement-calcul-global';
  fermeturePonctuelleList: FermeturePonctuelleDTO[] = [];
  planProduction: string;
  displayDialogMassiveTreatment: boolean = false;
  dateConditionnement: Date = null;
  selectedConditionnementList: any[] = [];

  constructor(private route: ActivatedRoute,
              private routeMapSvc: RoutemapService,
              private pcSvc: PreparationConditionnementService,
              public utils: UtilsService,
              public printMenuSvc: PrintMenuService,
              private i8nSvc: InternationalizationService,
              private prodSvc: ProductionService,
              private fermeturePonctuelleSvc: FermeturePoncutelleService,
              private conditionnementSvc: PreparationConditionnementService,
              private toastSvc: ToastService) {
  }

  ngOnInit(): void {
    this.routeSubscription();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subscriptionRoute);
    this.utils.unsubscribe(this.subscriptionCalcul);
    this.utils.unsubscribe(this.updateDateSub);
  }

  routeSubscription = () => {
    this.subscriptionRoute = this.route.parent.data
      .subscribe((data: { preparationConditionnementSupplier: PreparationConditionnementSupplier }) => {
        if (data.preparationConditionnementSupplier) {
          this.idPlanProduction = data.preparationConditionnementSupplier.idPlanProduction;
          this.startCalculation(data.preparationConditionnementSupplier.isRefresh);
        }
      });
  };

  goToProductPage = (idProduct: number) => window.open(`/gestionproduits(secondary:gestionproduits/produit/true/${idProduct}/conditionnement)`, '_blank');

  goToPlcPage = (idClient: number, idPlc: number) => window.open(`/gestion-clients(secondary:point-de-livraison/${idClient}/${idPlc}/conditionnement/regles-regroupements)`, '_blank');

  closeErrors = () => {
    this.displayErrors = false;
  }

  startCalculation = async (refresh?: boolean) => {
    this.NoDataText = 'En cours de chargement...';
    this.loadingVisible = true;
    this.subscriptionCalcul = this.pcSvc.startCalculation(this.idPlanProduction, refresh)
      .subscribe(data => {
          const res: any = data;
          if (res.one?.reports?.length > 0)
            this.prodSvc.announceDisplayCalculCondiErrors(res.one.reports);
          this.pcSvc.getAllResults(this.idPlanProduction)
            .subscribe(data => {
              this.data = data.one.results;
              this.planProduction = data.one.planProduction;
              if (data.one.results.length > 0)
                this.fetchDateFermeturePonctuelle
            });
          this.loadingVisible = false;
        }
      );
  };

  previousStep = () => {
    this.routeMapSvc.goToSecondaryRoute(['steps', 'plan-production', this.idPlanProduction]);
  }

  printEditionConditionnement = (): void => {
    this.pcSvc.announcePrintConditionnement();
  }

  changeCollapseAll = () => {
    this.expandAll = !this.expandAll;
  }

  isSubRecipe(data: LigneConditionnementDetailsDto): boolean {
    return data.idParentDeclinaison != null
  }

  fetchDateFermeturePonctuelle = (): void => {
    const filter = new FermeturePonctuelleFilter();
    filter.idUniteProduction = this.data[0].idUdp;
    filter.perimetre = 'CONDITIONNEMENT';
    const minDate: Date = this.data.map(ct => new Date(ct.dateConditionnement)).reduce((min, d) => d < min ? d : min);
    const maxDate: Date = this.data.map(ct => new Date(ct.dateConditionnement)).reduce((max, d) => d > max ? d : max);
    filter.dateDebut = this.utils.customFormatDate(new Date(minDate).toDateString(), this.utils.findDateFormat(new Date(minDate).toDateString()), 'YYYY-MM-DD');
    filter.dateFin = this.utils.customFormatDate(new Date(maxDate).toDateString(), this.utils.findDateFormat(new Date(maxDate).toDateString()), 'YYYY-MM-DD');
    this.fermeturePonctuelleSvc.getFermeturePonctuelle(filter).subscribe(response => {
      this.fermeturePonctuelleList = response;
    });
  }
  isDateFermeturePonctuelle = (row: any): boolean => {
    return this.fermeturePonctuelleSvc.isDateOnFermeturePonctuelle(row.dateConditionnement, this.fermeturePonctuelleList);
  }

  onEditorPreparing = (event: any) => {
    const dataField: string = event.dataField;
    if (dataField === 'dateConditionnement') {
      const originalRow = event.row.data;
      const self = this
      event.editorOptions.onValueChanged = function (args: any) {
        const newDateValue = args.value instanceof Date ? args.value.getTime() : args.value;
        self.updateDateSub = self.conditionnementSvc.updateConditionnementDate([originalRow.id], newDateValue).subscribe(res => {
          if (res) {
            originalRow['dateConditionnement'] = newDateValue;
            self.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Date de conditionnement mise à jour`);
          }
        });
      }
    }
  }

  closeDialogMassiveTreatment = () => {
    this.displayDialogMassiveTreatment = false;
  }

  applyMassiveTreatment = () => {
    const selectedIds = this.selectedConditionnementList.map(ct => ct.id);
    this.conditionnementSvc.updateConditionnementDate(selectedIds, this.dateConditionnement).subscribe(res => {
      if (res) {
        this.data.forEach(ct => {
          if (selectedIds.includes(ct.id)) {
            ct['dateConditionnement'] = this.dateConditionnement;
          }
        })
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Date de conditionnement mise à jour`);
        this.displayDialogMassiveTreatment = false;
      }
    })
  }

  onSelectionChanged = (event: any): void => {
    this.selectedConditionnementList = event.selectedRowsData;
  }

  openMassiveTreatmentDialog = () => {
    this.displayDialogMassiveTreatment = true;
  }

  public readonly ButtonThemeEnum = ButtonThemeEnum;
}
